import Model from "models/Model";

class DataQualityResult extends Model {
    constructor(...args) {
        super(...args);
        this.initialize = this.initialize.bind(this);
    }

    initialize(options) {
        // id-key-data_shortname
        this.set(
            "compositeId",
            `${options.id}-${options.key}-${options.data._shortname}`,
        );
    }
}

DataQualityResult.prototype.defaults = {
    // previously anonymous attributes
    compositeId: null,
};

DataQualityResult.prototype.idAttribute = "compositeId";

export default DataQualityResult;



// WEBPACK FOOTER //
// ./app/models/DataQualityResult.js